import { CalendarState, DayData } from '../types';

const STORAGE_KEY = 'interview-prep-calendar';

export function saveToLocalStorage(state: Partial<CalendarState>): void {
  try {
    const existingData = loadFromLocalStorage();
    const updatedData = { ...existingData, ...state };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedData));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
}

export function loadFromLocalStorage(): Partial<CalendarState> {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (data) {
      const parsed = JSON.parse(data);
      // Convert date strings back to Date objects
      if (parsed.currentMonth) {
        parsed.currentMonth = new Date(parsed.currentMonth);
      }
      if (parsed.selectedDate) {
        parsed.selectedDate = new Date(parsed.selectedDate);
      }
      return parsed;
    }
  } catch (error) {
    console.error('Error loading from localStorage:', error);
  }
  return {};
}

export function saveDayData(dateKey: string, dayData: DayData): void {
  const state = loadFromLocalStorage();
  const updatedDayData = {
    ...state.dayData,
    [dateKey]: dayData
  };
  saveToLocalStorage({ dayData: updatedDayData });
}

export function calculateStats(dayData: Record<string, DayData>) {
  let totalProblemsSolved = 0;
  let currentStreak = 0;
  let tempStreak = 0;
  
  const sortedDates = Object.keys(dayData).sort();
  const today = new Date().toISOString().split('T')[0];
  
  for (let i = sortedDates.length - 1; i >= 0; i--) {
    const dateKey = sortedDates[i];
    const day = dayData[dateKey];
    
    if (day.completed) {
      if (dateKey === today || (i < sortedDates.length - 1 && 
          new Date(sortedDates[i + 1]).getTime() - new Date(dateKey).getTime() === 86400000)) {
        tempStreak++;
      } else {
        break;
      }
    }
    
    // Count DSA problems solved
    day.tasks.forEach(task => {
      if (task.category === 'dsa' && task.completed) {
        totalProblemsSolved++;
      }
    });
  }
  
  currentStreak = tempStreak;
  
  return { totalProblemsSolved, currentStreak };
}